export async function downloadFileInBrowser(link: string, fileName = "file") {
  try {
    const res = await fetch(link, { mode: "cors" });
    const blob = await res.blob();

    const url = URL.createObjectURL(blob);

    const linkEl = document.createElement("a");
    linkEl.href = url;
    linkEl.target = "_blank";
    linkEl.download = fileName;

    linkEl.click();

    URL.revokeObjectURL(url);
  } catch {
    const linkEl = document.createElement("a");
    linkEl.href = link;
    linkEl.target = "_blank";
    linkEl.download = fileName;
    linkEl.click();
  }
}
